import "./GarageDoorRepairNorthShore.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageIntro from "./sections/GarageIntro";
import GarageServices from "./sections/GarageServices";
import Partners from "./sections/Partners";
import GarageProcess from "./sections/GarageProcess";
import WhyUs from "./sections/WhyUs";
import Locations from "./sections/Locations";
import GarageReviews from "./sections/GarageReviews";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import CorporateFooter from "./sections/CorporateFooter";
export default function GarageDoorRepairNorthShorePage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageIntro />
      <GarageServices />
      <Partners />
      <GarageProcess />
      <WhyUs />
      <Locations />
      <GarageReviews />
      <GarageFaq />
      <GarageCta />
      <CorporateFooter />
    </div>;
}